module.exports = __webpack_public_path__ + "img/homepage_7.96ac232d.png";